import { Meta } from '../types/docs';

const META: Meta = {
  name: 'clicked_recently_deleted_upgrade_prompt',
  description: 'Tracks when a user clicks the recently deleted upgrade prompt',
  params: [],
};

export default META;
